import { useAppDispatch, useAppSelector } from "../../../../store/store";
import SidebarCollapse from "../../../app/SidebarCollapse";
import RadioInput from "../../../general/RadioInput";
import SliderInput from "../../../general/SliderInput/index";
import { getValueUnit } from "../../../general/editUtils";
import SelectInput from "../../../general/SelectInput";
import { EditableProps } from "../../editableProps";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateReceiptStyles } from "@builder/store/slices/BuilderSlice/builderSlice";
import { ReceiptNode } from "@common/build/types";

const ReceiptTypography: React.FC<EditableProps> = ({ parent, title, receiptLayoutType }: EditableProps) => {
    const dispatch = useAppDispatch();

    const selected = useAppSelector(getSelectedNode) as ReceiptNode;

    if (!receiptLayoutType) return;

    const styles = selected.styles?.[receiptLayoutType];

    //Text Alignment
    const textAlignment = styles?.textAlign?.toString() || "";
    const alignmentOptions = [
        { value: "left", img: "/text-align-left.svg", checked: textAlignment === "left" },
        { value: "center", img: "/text-align-center.svg", checked: textAlignment === "center" },
        { value: "right", img: "/text-align-right.svg", checked: textAlignment === "right" },
        { value: "justify", img: "/text-align-justify.svg", checked: textAlignment === "justify" }
    ];
    const alignmentCallback = (value: string): void => {
        type TextAlign = "start" | "end" | "left" | "right" | "center" | "justify" | "match-parent";

        dispatch(
            updateReceiptStyles({
                type: receiptLayoutType,
                styles: { textAlign: value as TextAlign }
            })
        );
    };

    //Font Size
    const fontSizeString = styles?.fontSize?.toString() || "";
    const fontSize = getValueUnit(fontSizeString);
    const fontSizeCallback = (value: string, unit: string): void => {
        dispatch(
            updateReceiptStyles({
                type: receiptLayoutType,
                styles: { fontSize: value + unit }
            })
        );
    };

    //Font Weight
    const fontWeight = styles?.fontWeight?.toString() || "";
    const fontWeightOptions = {
        "300": "300",
        "400": "400",
        "500": "500",
        "600": "600",
        "700": "700",
        "800": "800"
    };
    const fontWeightCallback = (value: string): void => {
        dispatch(
            updateReceiptStyles({
                type: receiptLayoutType,
                styles: { fontWeight: value }
            })
        );
    };

    return (
        <SidebarCollapse title={title ? title : "Receipt Typography"} parent={parent}>
            <RadioInput title={"Alignment"} groupName="textAlignment" options={alignmentOptions} callback={alignmentCallback} />
            <SliderInput title="Font Size" min={0} max={50} callback={fontSizeCallback} value={fontSize.value} unit={fontSize.unit} />
            <SelectInput title="Font Weight" value={fontWeight} options={fontWeightOptions} callback={fontWeightCallback} noTranslate />
        </SidebarCollapse>
    );
};

export default ReceiptTypography;
